import { DataSource, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutWireCodeList extends Layout {
    searchpanelWireCodes: SearchPanel;
    sourceWirecodeList: DataSource;
    tableWireCodeList: Table;
    textboxFuelInterfaceId: Textbox;
    textboxIsActive: Textbox;
    textboxSearchWireCode: Textbox;
    textboxWireType: Textbox;
}
